/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { View, Text } from '@components/atoms'
import { Modal } from '@components/molecules'
import SignatureCanvas from 'react-signature-canvas'
import { deepPurple } from '@mui/material/colors'

interface PropsType {
	showModal: boolean
	onSubmit: (url: string) => void
	onClose: () => void
	autoDate: any
	setAutoDate: any
}

export function SignatureInputModal(props: PropsType) {
	const { showModal, onClose, autoDate, setAutoDate } = props

	const sigRef = React.useRef<any>(null)

	const onSubmit = () => {
		const sigURL = sigRef.current?.toDataURL()
		props.onSubmit(sigURL)
	}

	return (
		<Modal
			target="newGroup"
			title="문서 서명"
			show={showModal}
			onSubmit={onSubmit}
			onCloseModal={onClose}
			closeStatus="inherit"
			closeTitle="취소"
			submitTitle="확인"
			style={{ maxWidth: '43rem' }}
		>
			<View css={style}>
				<View className="signatureOuterView">
					<View className="signatureView">
						<View className="signatureBlockView">
							<SignatureCanvas
								velocityFilterWeight={1}
								ref={sigRef}
								canvasProps={{
									width: '600',
									height: 200,
									className: 'sigCanvas',
								}}
							/>
						</View>
					</View>
					<View className="signatureMessageView">
						<Text category="p2">자동으로 서명 날짜와 시간이 입력됩니다.</Text>
						<Text category="p2">위 서명란에 서명해 주세요</Text>
					</View>
				</View>
			</View>
		</Modal>
	)
}

const style = css({
	maxWidth: '44rem',
	margin: '0 auto',
	padding: '2rem 1rem',

	'.signatureMessageView': {
		padding: '1rem 0.5rem 0',
		color: deepPurple['A400'],
	},

	'.signatureOuterView': {
		'.signatureView': {
			display: 'flex',
			justifyContent: 'center',

			'.signatureBlockView': {
				display: 'inline-block',
				background: deepPurple[50],
				borderBottom: '1px solid',
				borderColor: deepPurple['A400'],
				borderRadius: '5px 5px 0 0',
			},
		},
	},
})
